import { initializeApp } from "firebase/app";

const getRequiredEnv = (name: string): string => {
  const value = process.env[name];

  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }

  return value;
};

const firebaseConfig = {
  apiKey: getRequiredEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: getRequiredEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: getRequiredEnv("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: getRequiredEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: getRequiredEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: getRequiredEnv("REACT_APP_FIREBASE_APP_ID"),
};

const app = initializeApp(firebaseConfig);

export default app;
